// extracted by mini-css-extract-plugin
export default {"root":"AxisCell_root__DjEax","selected":"AxisCell_selected__I-LaG","handle":"AxisCell_handle__fmCVL"};